export default __webpack_public_path__ + "static/media/editrole.4eae4732.svg";